module.exports = __webpack_public_path__ + "static/Steamgraph-cdcbcaf442a6360a1a019faecc9bd0bc.png";